import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';

export interface IAirportCodeValidator {
  validate(code: string): Observable<boolean>;
}

export const AIRPORT_CODE_VALIDATOR_TOKEN = new InjectionToken('Core.IAirportCodeValidator');
